/* tslint:disable */
/* eslint-disable */
/**
 * Melco Reporting APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportingMelcoMachineStatisticsModelsMachineDesignListItem,
    ReportingMelcoMachineStatisticsModelsMachineDesignListItemFromJSON,
    ReportingMelcoMachineStatisticsModelsMachineDesignListItemFromJSONTyped,
    ReportingMelcoMachineStatisticsModelsMachineDesignListItemToJSON,
    ReportingMelcoModelsCustomWarning,
    ReportingMelcoModelsCustomWarningFromJSON,
    ReportingMelcoModelsCustomWarningFromJSONTyped,
    ReportingMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItem
 */
export interface ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItem {
    /**
     * 
     * @type {Array<ReportingMelcoMachineStatisticsModelsMachineDesignListItem>}
     * @memberof ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItem
     */
    list: Array<ReportingMelcoMachineStatisticsModelsMachineDesignListItem>;
    /**
     * 
     * @type {Array<ReportingMelcoModelsCustomWarning>}
     * @memberof ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItem
     */
    warning_list?: Array<ReportingMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItem
     */
    total: number;
}

export function ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItemFromJSON(json: any): ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItem {
    return ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItemFromJSONTyped(json, false);
}

export function ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ReportingMelcoMachineStatisticsModelsMachineDesignListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ReportingMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItemToJSON(value?: ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineDesignListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ReportingMelcoMachineStatisticsModelsMachineDesignListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ReportingMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


